export enum AppointmentAttendanceTypes {
    Telehealth = "TELEHEALTH"
}